var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_20680",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 21,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_20680)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_19_20680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9531 7.16895C11.4281 7.16895 6.95312 11.6464 6.95312 17.1689C6.95312 21.5881 9.81812 25.3356 13.7906 26.6564C14.2906 26.7506 14.474 26.4414 14.474 26.1756C14.474 25.9381 14.4656 25.3089 14.4615 24.4756C11.6798 25.0789 11.0931 23.1339 11.0931 23.1339C10.6381 21.9798 9.98062 21.6714 9.98062 21.6714C9.07479 21.0514 10.0506 21.0639 10.0506 21.0639C11.0548 21.1339 11.5823 22.0939 11.5823 22.0939C12.474 23.6231 13.9231 23.1814 14.4948 22.9256C14.5848 22.2789 14.8423 21.8381 15.1281 21.5881C12.9073 21.3381 10.5731 20.4781 10.5731 16.6464C10.5731 15.5548 10.9606 14.6631 11.6023 13.9631C11.4898 13.7106 11.1523 12.6939 11.6898 11.3164C11.6898 11.3164 12.5273 11.0481 14.4398 12.3414C15.2398 12.1189 16.0898 12.0089 16.9398 12.0039C17.7898 12.0089 18.6398 12.1189 19.4398 12.3414C21.3398 11.0481 22.1773 11.3164 22.1773 11.3164C22.7148 12.6939 22.3773 13.7106 22.2773 13.9631C22.9148 14.6631 23.3023 15.5548 23.3023 16.6464C23.3023 20.4881 20.9648 21.3339 18.7398 21.5798C19.0898 21.8798 19.4148 22.4931 19.4148 23.4298C19.4148 24.7681 19.4023 25.8431 19.4023 26.1681C19.4023 26.4306 19.5773 26.7431 20.0898 26.6431C24.0906 25.3314 26.9531 21.5814 26.9531 17.1689C26.9531 11.6464 22.4756 7.16895 16.9531 7.16895Z",
    fill: "black"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_20680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.95312,
    y: 6.92188,
    width: 20,
    height: 20,
    fill: "#E2E8F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_20680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6.95312 6.92188)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_19_20680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6.95312 6.92188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.20141c19cef3a10044b2e5d17175c470.svg";
export { ForwardRef as ReactComponent };